import React from 'react';
import { Chip, createTheme, ThemeProvider } from '@mui/material';
import styles from './PreferenceTypeOne.module.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0194D3'
    }
  },
  color: 'white'
});

export function PreferenceTypeOne({ fields }) {
  return (
    <div className={styles.PreferenceParent}>
      <div className={styles.preferenceList}>
        {fields?.length !== 0 ? (
          fields?.map((item) => {
            const { skillName, id } = item;
            return (
              <ThemeProvider key={id} theme={theme}>
                <Chip
                  label={skillName}
                  color="primary"
                  variant="filled"
                  sx={{ color: 'white', fontFamily: 'Gotham-Book' }}
                />
              </ThemeProvider>
            );
          })
        ) : (
          <div className={styles.noPreferenceMSG}>No Skills preference Selected</div>
        )}
      </div>
    </div>
  );
}
